export const FILE_TYPES = {
    IMAGE: "IMAGE",
    AUDIO: "AUDIO",
    VIDEO: "VIDEO",
    PDF: "PDF",
};